import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import FileAppResource from './FileAppResource';
import WorkspaceAppResource from "./WorkspaceAppResource";

class DocumentTagAppResource extends AppResource {
    /**
     * @returns {string}
     */
    appResourceType() {
        return 'document-tag';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'documents/tags';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'created_at',
            'updated_at',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'name',
            'files',
            'slug',
            'hub',
            'hubUuid'
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            files: FileAppResource,
            hub: WorkspaceAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return [];
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            name: {
                type: 'string',
                presence: true,
            },
            hubUuid: {
                type: 'string',
                presence: true,
            },
        };
    }
}

export const APPRAISAL_DOCUMENT_TAG_SLUG = 'appraisal';
export const PURCHASE_AGREEMENT_DOCUMENT_TAG_SLUG = 'purchase-agreement';
export const CLOSING_DISCLOSURES_DOCUMENT_TAG_SLUG = 'closing-disclosures';
export const SURVEY_DOCUMENT_TAG_SLUG = 'survey';
export const HOMEOWNERS_INSURANCE_DOCUMENT_TAG_SLUG = 'homeowners-insurance';
export const TITLE_DOCUMENT_TAG_SLUG = 'title';
export const HOME_WARRANTY_DOCUMENT_TAG_SLUG = 'home-warranty';
export const TITLE_INSURANCE_DOCUMENT_TAG_SLUG = 'title-insurance';
export const INSPECTION_REPORT_DOCUMENT_TAG_SLUG = 'inspection-report';
export const PURCHASE_CONTRACT_DOCUMENT_TAG_SLUG = 'purchase-contract';
export const FLOOR_PLAN_DOCUMENT_TAG_SLUG = 'floor-plan';
export const MORTGAGE_DOCUMENT_TAG_SLUG = 'mortgage';

export const DOCUMENT_TAG_ALL = {
    APPRAISAL_DOCUMENT_TAG_SLUG,
    PURCHASE_AGREEMENT_DOCUMENT_TAG_SLUG,
    CLOSING_DISCLOSURES_DOCUMENT_TAG_SLUG,
    SURVEY_DOCUMENT_TAG_SLUG,
    HOMEOWNERS_INSURANCE_DOCUMENT_TAG_SLUG,
    TITLE_DOCUMENT_TAG_SLUG,
    HOME_WARRANTY_DOCUMENT_TAG_SLUG,
    TITLE_INSURANCE_DOCUMENT_TAG_SLUG,
    INSPECTION_REPORT_DOCUMENT_TAG_SLUG,
    PURCHASE_CONTRACT_DOCUMENT_TAG_SLUG,
    FLOOR_PLAN_DOCUMENT_TAG_SLUG,
    MORTGAGE_DOCUMENT_TAG_SLUG,
}

export default DocumentTagAppResource;
